import main from './video';
export default main;